module.exports = __webpack_public_path__ + "img/modelo4.85cfaacd.png";